const config = {
  // Development Configuration
  DEV: {
    ApiURL: "https://localhost:7082/api/",
  },


  // QA Configuration
  QA: {
    ApiURL: "https://labplanningqaapi.vaanamtechdemo.com/api/",

  },

  // UAT Configuration
  UAT: {
    //  ApiURL: "http://172.16.17.85:1080",
    ApiURL: "https://labuatapi.smil-e.com/api/",
   
  },

  // sl3 UAT Configuration
  PROD: {
    //  ApiURL: "http://172.16.17.85:1080",
    ApiURL: "https://labapi.smil-e.com/api/",

  },
};

// Enable a specific environment by uncommenting one of the following lines
//const currentConfig = config.DEV;
//const currentConfig = config.QA;
//const currentConfig = config.UAT;
const currentConfig = config.PROD;

// Export using ES Modules syntax
export const APIURL = currentConfig.ApiURL;

export const URL = APIURL.replace("/api/", "");

export default currentConfig;
 